import { connectivityReducer } from '../connectivity/connectivity.store';
import { environmentReducer } from '../environment/environment.reducer';
import { pdfModalReducer } from '../pdf-modal/redux/pdf-modal.reducer';
import { seReportReducer } from '../report/report.reducer';
import { externalDocsReducer } from '../se-external-docs/redux/external-docs.reducer';
import { seSideNavReducer } from '../se-side/redux/se-side-nav.reducer';
import { seSideKeyImagesReducer } from '../se-side/se-side-components/se-side-key-images-container/redux/se-side-key-images-container.reducer';
import { seSidePatientHistoryReducer } from '../se-side/se-side-components/se-side-patient-history/redux/se-side-patient-history.reducer';
import { seStepperSideNavParentReducer } from "../se-stepper-side-nav/redux/se-stepper-side-nav.reducer";
import { seButtonsToolbarReducer } from '../se-toolbar/se-buttons-toolbar/redux/se-buttons-toolbar.reducer';
import { seHeaderToolbarReducer } from '../se-toolbar/se-header-toolbar/se-header-toolbar.reducer';
import { searchPageReducer } from '../search-page/redux/search-page.reducer';
import { seSignReducer } from '../sign/estensasign.reducer';

export const rootReducerMap = {
    buttonsToolbar: seButtonsToolbarReducer,
    connectivity: connectivityReducer,
    environment: environmentReducer,
    externalDocs: externalDocsReducer,
    headerToolbar: seHeaderToolbarReducer,
    pdfModal: pdfModalReducer,
    report: seReportReducer,
    searchPage: searchPageReducer,
    seSidePatientHistory: seSidePatientHistoryReducer,
    seSideKeyImages: seSideKeyImagesReducer,
    seSideNav: seSideNavReducer,
    sign: seSignReducer,
    seStepperSideNav: seStepperSideNavParentReducer
};
